
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("iyAOY", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $90a55255f4b0ff64$export$85183a312807388d);
$parcel$export(module.exports, "DATASOURCE_DEFAULT_LAYOUT", () => $90a55255f4b0ff64$export$60efea3f80310017);
const $90a55255f4b0ff64$export$85183a312807388d = 'media';
const $90a55255f4b0ff64$export$60efea3f80310017 = 'wide';

});

parcelRegister("8hi3G", function(module, exports) {
$parcel$export(module.exports, "default", () => $286ce1d10647f1ec$export$2e2bcd8739ae039);

var $cJJTb = parcelRequire("cJJTb");

var $a5qVj = parcelRequire("a5qVj");

const $286ce1d10647f1ec$var$LazyLinkPickerComponent = (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("78End")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })), {
    moduleId: "../platform/packages/linking-platform/link-picker/src/ui/link-picker/index.tsx"
});
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $286ce1d10647f1ec$var$_default_1 = (0, $a5qVj.composeLinkPicker)($286ce1d10647f1ec$var$LazyLinkPickerComponent);
var $286ce1d10647f1ec$export$2e2bcd8739ae039 = $286ce1d10647f1ec$var$_default_1;

});
parcelRegister("a5qVj", function(module, exports) {
$parcel$export(module.exports, "composeLinkPicker", () => $445aa1c7c74ad15e$export$922eb685ceb4a294);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $cJJTb = parcelRequire("cJJTb");

var $dwOcU = parcelRequire("dwOcU");

var $iZbtd = parcelRequire("iZbtd");

var $hRJrl = parcelRequire("hRJrl");

var $gkBZT = parcelRequire("gkBZT");

var $lPv5L = parcelRequire("lPv5L");

var $2VmqJ = parcelRequire("2VmqJ");
const $445aa1c7c74ad15e$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $445aa1c7c74ad15e$export$a2495bb1f182689d = {
    packageName: '',
    packageVersion: '',
    componentName: (0, $iZbtd.COMPONENT_NAME),
    source: (0, $iZbtd.COMPONENT_NAME)
};
const $445aa1c7c74ad15e$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": $445aa1c7c74ad15e$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $445aa1c7c74ad15e$var$fixedWidthContainerStyles = null;
const $445aa1c7c74ad15e$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $9fU1q.default)([
            "_1bsb1ubl"
        ])
    });
};
const $445aa1c7c74ad15e$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $bSJIT.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $445aa1c7c74ad15e$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: $445aa1c7c74ad15e$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hRJrl.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2VmqJ.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $iZbtd.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($445aa1c7c74ad15e$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gkBZT.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJJTb.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lPv5L.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(RootComponent, {
            ...props,
            "data-testid": $445aa1c7c74ad15e$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props)))))))));
    });
};

});
parcelRegister("iZbtd", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $874851f5bded9620$export$85183a312807388d);
$parcel$export(module.exports, "COMPONENT_NAME", () => $874851f5bded9620$export$fc44104665f4d1e5);
$parcel$export(module.exports, "RECENT_SEARCH_LIST_SIZE", () => $874851f5bded9620$export$452f1062ecf44be7);
$parcel$export(module.exports, "LINK_PICKER_WIDTH_IN_PX", () => $874851f5bded9620$export$bf31a09f182d5584);
$parcel$export(module.exports, "LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK", () => $874851f5bded9620$export$542fb16962bf430c);
const $874851f5bded9620$export$85183a312807388d = 'media';
const $874851f5bded9620$export$fc44104665f4d1e5 = 'linkPicker';
const $874851f5bded9620$export$452f1062ecf44be7 = 5;
const $874851f5bded9620$export$bf31a09f182d5584 = 342;
const $874851f5bded9620$export$542fb16962bf430c = '290px';

});

parcelRegister("hRJrl", function(module, exports) {
$parcel$export(module.exports, "LinkPickerSessionProvider", () => $5e7bdb47a104f04e$export$2f19832fd2d620ca);
$parcel$export(module.exports, "useLinkPickerSessionId", () => $5e7bdb47a104f04e$export$36ecc935abdc3636);

var $bSJIT = parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $ktp0q = parcelRequire("ktp0q");
const $5e7bdb47a104f04e$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $5e7bdb47a104f04e$export$3285420c698bc605 = /*#__PURE__*/ (0, $bSJIT.createContext)($5e7bdb47a104f04e$export$c07727f5eddb98f);
const $5e7bdb47a104f04e$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $bSJIT.useRef)((0, $7RHfd.default)());
    (0, $bSJIT.useEffect)(()=>{
        (0, $ktp0q.startUfoExperience)((0, $ktp0q.ufoExperience).mounted, sessionId);
        return ()=>(0, $ktp0q.abortUfoExperience)((0, $ktp0q.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($5e7bdb47a104f04e$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $5e7bdb47a104f04e$export$36ecc935abdc3636 = ()=>(0, $bSJIT.useContext)($5e7bdb47a104f04e$export$3285420c698bc605);

});
parcelRegister("ktp0q", function(module, exports) {
$parcel$export(module.exports, "ufoExperience", () => $539ed4dd5267f0de$export$f9c7780c574346a2);
$parcel$export(module.exports, "startUfoExperience", () => $539ed4dd5267f0de$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $539ed4dd5267f0de$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $539ed4dd5267f0de$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $539ed4dd5267f0de$export$b1021040eb94cdca);

var $5bALc = parcelRequire("5bALc");

var $mx1V1 = parcelRequire("mx1V1");
const $539ed4dd5267f0de$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $539ed4dd5267f0de$var$ufoExperiences = {
    [$539ed4dd5267f0de$export$f9c7780c574346a2.mounted]: new (0, $5bALc.ConcurrentExperience)($539ed4dd5267f0de$export$f9c7780c574346a2.mounted, {
        type: (0, $mx1V1.ExperienceTypes).Load,
        performanceType: (0, $mx1V1.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $539ed4dd5267f0de$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $539ed4dd5267f0de$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $539ed4dd5267f0de$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $539ed4dd5267f0de$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $539ed4dd5267f0de$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $539ed4dd5267f0de$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $539ed4dd5267f0de$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $539ed4dd5267f0de$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};

});


parcelRegister("gkBZT", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $86bd4ba36f3556da$export$e926676385687eaf);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $ktp0q = parcelRequire("ktp0q");

var $iZbtd = parcelRequire("iZbtd");

var $9VCFZ = parcelRequire("9VCFZ");

var $hRJrl = parcelRequire("hRJrl");

var $aE8w5 = parcelRequire("aE8w5");

var $6cNNg = parcelRequire("6cNNg");
function $86bd4ba36f3556da$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $hRJrl.useLinkPickerSessionId)();
    const handleError = (0, $bSJIT.useCallback)((error, info)=>{
        var _window;
        // Fire Analytics event
        createAnalyticsEvent((0, $9VCFZ.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: ((_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent) || 'unknown',
            error: error.toString(),
            componentStack: (info === null || info === void 0 ? void 0 : info.componentStack) ?? ''
        })).fire((0, $iZbtd.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $ktp0q.failUfoExperience)((0, $ktp0q.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aE8w5.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $6cNNg.ErrorBoundaryFallback)
    }, children);
}

});
parcelRegister("9VCFZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fd393ac45f711c1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8ad800c149f887c26cf6e1c701c20ed0>>
 * @codegenCommand afm workspace @atlaskit/link-picker codegen-analytics
 */ function $0fd393ac45f711c1$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $0fd393ac45f711c1$export$2e2bcd8739ae039 = $0fd393ac45f711c1$var$createEventPayload;

});

parcelRegister("aE8w5", function(module, exports) {
$parcel$export(module.exports, "BaseErrorBoundary", () => $934dbfe50c079690$export$688779ac61ee945f);

var $bSJIT = parcelRequire("bSJIT");
class $934dbfe50c079690$export$688779ac61ee945f extends (0, $bSJIT.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ErrorComponent, null);
        return children;
    }
}

});

parcelRegister("6cNNg", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryFallback", () => $a6c08ad6478f64b9$export$8a28b7e38e4685dd);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $f0Pt4 = parcelRequire("f0Pt4");
var $4vLTk = parcelRequire("4vLTk");

var $iZbtd = parcelRequire("iZbtd");

var $dNLOD = parcelRequire("dNLOD");

var $f4SD9 = parcelRequire("f4SD9");

var $lvzhv = parcelRequire("lvzhv");
const $a6c08ad6478f64b9$var$errorBoundaryFallbackStyles = null;
const $a6c08ad6478f64b9$var$messages = (0, $f0Pt4.defineMessages)({
    heading: {
        defaultMessage: 'Something went wrong!',
        description: 'Heading displayed when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.heading'
    },
    description: {
        defaultMessage: 'Try reloading the page.',
        description: 'Body message shown underneath the heading when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.description'
    }
});
const $a6c08ad6478f64b9$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $4vLTk.default)();
    const header = intl.formatMessage($a6c08ad6478f64b9$var$messages.heading);
    const description = intl.formatMessage($a6c08ad6478f64b9$var$messages.description);
    return /*#__PURE__*/ $bSJIT.createElement((0, $lvzhv.MinHeightContainer), {
        minHeight: (0, $iZbtd.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $9fU1q.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $f4SD9.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $dNLOD.GenericErrorSVG), null),
        description: description
    }));
};

});
parcelRegister("dNLOD", function(module, exports) {
$parcel$export(module.exports, "GenericErrorSVG", () => $1fcd810b879691dc$export$e54420a1a27457a4);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $1fcd810b879691dc$var$SIZE = 96;
const $1fcd810b879691dc$var$genericErrorStyles = null;
const $1fcd810b879691dc$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $9fU1q.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};

});

parcelRegister("f4SD9", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $5ced0d8c7ac42e38$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $7WQx2 = parcelRequire("7WQx2");

var $6X9z7 = parcelRequire("6X9z7");

var $8aT4G = parcelRequire("8aT4G");
const $5ced0d8c7ac42e38$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o",
    whiteSpaceNormal: "_o5724jg8"
};
const $5ced0d8c7ac42e38$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $6X9z7.Flex), {
        xcss: (0, $jDsoo.cx)($5ced0d8c7ac42e38$var$styles.containerV2, $5ced0d8c7ac42e38$var$styles.whiteSpaceNormal),
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage === null || renderImage === void 0 ? void 0 : renderImage(), /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};

});

parcelRegister("lvzhv", function(module, exports) {
$parcel$export(module.exports, "MinHeightContainer", () => $36d1836be6113bc7$export$42134e2a251518b3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $36d1836be6113bc7$var$minHeightComponentStyles = null;
const $36d1836be6113bc7$export$42134e2a251518b3 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});

});



parcelRegister("lPv5L", function(module, exports) {
$parcel$export(module.exports, "LoaderFallback", () => $ce03b31ead22de9b$export$d96e921133238c41);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hDkm2 = parcelRequire("hDkm2");

var $lvzhv = parcelRequire("lvzhv");
const $ce03b31ead22de9b$var$styles = null;
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $ce03b31ead22de9b$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
        /**
     * Without tabs
     */ if ((plugins === null || plugins === void 0 ? void 0 : plugins.length) === 1) return hideDisplayText ? $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $ce03b31ead22de9b$export$d96e921133238c41 = (props)=>{
    const minHeight = $ce03b31ead22de9b$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $bSJIT.createElement((0, $lvzhv.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $9fU1q.default)([
            "_4cvr1h6o"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};

});

parcelRegister("2VmqJ", function(module, exports) {
$parcel$export(module.exports, "MessagesProvider", () => $0ccc9ee8d9e15e9c$export$54320b51a950d54a);

var $bSJIT = parcelRequire("bSJIT");

var $cyhvX = parcelRequire("cyhvX");
const $0ccc9ee8d9e15e9c$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cyhvX.LazyMessagesProvider), null, children);
};

});
parcelRegister("cyhvX", function(module, exports) {
$parcel$export(module.exports, "LazyMessagesProvider", () => $75fa3f8b434bacbd$export$d013d33430f9fb4b);

var $bSJIT = parcelRequire("bSJIT");

var $igKbN = parcelRequire("igKbN");

var $89wjR = parcelRequire("89wjR");

var $8zX7s = parcelRequire("8zX7s");
const $75fa3f8b434bacbd$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $igKbN.default), {
        defaultMessages: (0, $89wjR.default),
        loaderFn: (0, $8zX7s.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("89wjR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $058c11d29d47685b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lW8TW = parcelRequire("lW8TW");
var $058c11d29d47685b$export$2e2bcd8739ae039 = (0, $lW8TW.default);

});
parcelRegister("lW8TW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e5bb5553144a1d5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $8e5bb5553144a1d5$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Cancel',
    'fabric.linkPicker.button.insert': 'Insert',
    'fabric.linkPicker.button.save': 'Save',
    'fabric.linkPicker.clearLink': 'Clear',
    'fabric.linkPicker.clearLinkText': 'Clear text',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {no results} one {# result} other {# results}} found',
    'fabric.linkPicker.linkAriaLabel': 'Type or paste a link into the field',
    'fabric.linkPicker.linkHelperTextAriaLabel': 'Link display helper text',
    'fabric.linkPicker.linkHelperTextLabel': 'Give this link a title or description',
    'fabric.linkPicker.linkInvalid': 'Enter a valid URL.',
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': 'Paste a link',
    'fabric.linkPicker.linkTextAriaLabel': 'Link display text',
    'fabric.linkPicker.linkTextLabel': 'Display text (optional)',
    'fabric.linkPicker.linkTextPlaceholder': 'Text to display',
    'fabric.linkPicker.listTitle.recentlyViewedFormatted': 'Recently viewed',
    'fabric.linkPicker.listTitle.results': 'Results',
    'fabric.linkPicker.noEmbed': "Embed view isn't supported for this link. <a>More about why some Smart Links don't display content.</a>",
    'fabric.linkPicker.search.error.description': 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
    'fabric.linkPicker.search.error.heading': "We\u2019re having trouble loading data.",
    'fabric.linkPicker.search.error.retry': 'Refresh',
    'fabric.linkPicker.search.linkAriaLabel': 'Suggestions will appear below as you type into the field',
    'fabric.linkPicker.search.linkLabel': 'Search or paste a link',
    'fabric.linkPicker.search.linkPlaceholder': 'Find recent links or paste a new link',
    'fabric.linkPicker.search.noResults.description': 'Try again with a different term.',
    'fabric.linkPicker.search.noResults.heading': "We couldn\u2019t find anything matching your search.",
    'fabric.linkPicker.status.submitting': 'Submitting',
    'fabric.linkPicker.time.message.updated': 'Updated {time}',
    'fabric.linkPicker.time.message.viewed': 'Viewed {time}',
    'fabric.linkPicker.unhandledError.description': 'Try reloading the page.',
    'fabric.linkPicker.unhandledError.heading': 'Something went wrong!',
    foo: 'Default string'
};

});


parcelRegister("8zX7s", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $01e14fca953617ac$export$2b153a2030b0feb2);

var $7J5Id = parcelRequire("7J5Id");
const $01e14fca953617ac$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $7J5Id.locales)) {
            const messages = await (0, $7J5Id.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $7J5Id.locales)) {
            const messages = await (0, $7J5Id.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("7J5Id", function(module, exports) {
$parcel$export(module.exports, "locales", () => $32b275fa2911b4df$export$df1c34db1371eeed);

























const $32b275fa2911b4df$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("hagcX")),
    da: ()=>(parcelRequire("gbv3a")),
    de: ()=>(parcelRequire("a6WBs")),
    en_GB: ()=>(parcelRequire("i2u25")),
    en_ZZ: ()=>(parcelRequire("geevH")),
    en: ()=>Promise.resolve((parcelRequire("89wjR"))),
    es: ()=>(parcelRequire("4AvMi")),
    fi: ()=>(parcelRequire("1OXKz")),
    fr: ()=>(parcelRequire("56Dan")),
    hu: ()=>(parcelRequire("o4vJ4")),
    it: ()=>(parcelRequire("kgwRa")),
    ja: ()=>(parcelRequire("i6qdM")),
    ko: ()=>(parcelRequire("5lHX4")),
    nb: ()=>(parcelRequire("aKOim")),
    nl: ()=>(parcelRequire("lk433")),
    pl: ()=>(parcelRequire("3psVD")),
    pt_BR: ()=>(parcelRequire("peQEl")),
    ru: ()=>(parcelRequire("6Frk7")),
    sv: ()=>(parcelRequire("hVkhG")),
    th: ()=>(parcelRequire("gsiGh")),
    tr: ()=>(parcelRequire("9t29V")),
    uk: ()=>(parcelRequire("lpwFA")),
    vi: ()=>(parcelRequire("4Uk4J")),
    zh_TW: ()=>(parcelRequire("7bczp")),
    zh: ()=>(parcelRequire("lplUM"))
};

});
parcelRegister("hagcX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fGPtd").then(()=>parcelRequire('5MomH'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});



parcelRegister("gbv3a", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ciiYb").then(()=>parcelRequire('fYUKt'));

});

parcelRegister("a6WBs", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kbKei").then(()=>parcelRequire('frcqj'));

});

parcelRegister("i2u25", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6efBc").then(()=>parcelRequire('fliHE'));

});

parcelRegister("geevH", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7Y2fU").then(()=>parcelRequire('8zuw0'));

});

parcelRegister("4AvMi", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5849l").then(()=>parcelRequire('4gYQX'));

});

parcelRegister("1OXKz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7QGFR").then(()=>parcelRequire('fEWDk'));

});

parcelRegister("56Dan", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9nQbS").then(()=>parcelRequire('6wA32'));

});

parcelRegister("o4vJ4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jF2uM").then(()=>parcelRequire('57JwT'));

});

parcelRegister("kgwRa", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7z160").then(()=>parcelRequire('lvyFx'));

});

parcelRegister("i6qdM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("a6xQ1").then(()=>parcelRequire('6gr6z'));

});

parcelRegister("5lHX4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bo6Oq").then(()=>parcelRequire('dIRA5'));

});

parcelRegister("aKOim", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("14gg5").then(()=>parcelRequire('aDqRK'));

});

parcelRegister("lk433", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4sJc3").then(()=>parcelRequire('46PX2'));

});

parcelRegister("3psVD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fqKVQ").then(()=>parcelRequire('cC9u4'));

});

parcelRegister("peQEl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("PFcra").then(()=>parcelRequire('jkpZG'));

});

parcelRegister("6Frk7", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ccMRA").then(()=>parcelRequire('sBGJT'));

});

parcelRegister("hVkhG", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9waBk").then(()=>parcelRequire('auBLU'));

});

parcelRegister("gsiGh", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2ZNML").then(()=>parcelRequire('2IJWY'));

});

parcelRegister("9t29V", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9MT7Y").then(()=>parcelRequire('hn0A2'));

});

parcelRegister("lpwFA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kAky8").then(()=>parcelRequire('1F0e5'));

});

parcelRegister("4Uk4J", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4SaGv").then(()=>parcelRequire('lhFG8'));

});

parcelRegister("7bczp", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aRnE3").then(()=>parcelRequire('7Lxe4'));

});

parcelRegister("lplUM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("egvF4").then(()=>parcelRequire('8t9Jz'));

});






parcelRegister("78End", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("36aBu"),
    $kOunM("hxBTu")
]).then(()=>parcelRequire('4MxuW'));

});



//# sourceMappingURL=shared.7d23feb5.js.map
